import React, { useContext } from "react";
import _ from "lodash";

import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import firebase from "../../firebase";

const useStyles = makeStyles((theme) => ({
  root: {
    // display: "flex",
    // marginTop: theme.spacing(-1),
    // paddingTop: theme.spacing(-1),
    marginBottom: theme.spacing(-2),
    // marginLeft: theme.spacing(-1),
    // marginRight: theme.spacing(-0.4),
  },
  container: {
    // marginLeft: theme.spacing(-1),
    // marginRight: theme.spacing(1),
    // border:'solid',
    // borderWidth:'2px',
    // borderColor:'lightgrey'
  },
}));

export default function BannerContainer(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);

  return (
    <div className={classes.root}>
      {/*<Container className={classes.container}>*/}
      <Grid container direction={"row"}>
        <Grid item xs={12}>
          <img
            src={`../../icons/dashboard-banner-${language}.jpeg`}
            // height={120}
            onClick={() => {
              firebase.analytics().logEvent("dashboard_banner_clicked", {});
            }}
            width={`100%`}
          />
        </Grid>
      </Grid>

      {/*</Container>*/}
    </div>
  );
}
